import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Client } from 'app/shared/models/client.model';

@Component({
    selector: 'client-widget-item',
    templateUrl: './client-widget-item.component.html'
})

export class ClientWidgetItemComponent {

    @Input()
    clients: Client[];

    constructor(private router: Router) { }

    daysOverdue(endDate: number) {
        let currentDate = Date.now();
        if (currentDate > endDate) {
            let one_day = 1000 * 60 * 60 * 24;
            return Math.round((currentDate - endDate) / one_day);
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/widget/client-widget-item.component.ts